import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/utils/services/app.service';
import { console_log, DataProvider } from 'src/providers/data/data';
import { CallapiService } from 'src/providers/rest/callapi.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ContractListComponent implements OnInit {
  public csv1;
  public CompanyName = '';
  public Telephone = '';
  public cancel_flg = '';
  public check: boolean = false;
  public documentpdf;
  public ContractCount = '';
  public pages1;
  public wf_contract_list_detail: boolean;
  public today;
  public today_date;
  public management_company_code;
  public BusinessName;
  filteredItems = [];
  business_code;
  pages : number = 6;
  pageSize : number = 10;
  pageNumber : number = 0;
  currentIndex : number = 1;
  items = [];
  pagesIndex : Array<number>;
  pageStart : number = 1;
  public business_type = '';
  public BusinessType = [];
  constructor(
    private router: Router,
    public data: DataProvider,
    private appService: AppService,
    public rest: CallapiService,
    private spinner: NgxSpinnerService,
    protected datepipe: DatePipe,
  ) {
    this.BusinessType = [
      {code: "01", name: "農業・林業"},
      {code: "02", name: "漁業"},
      {code: "03", name: "鉱業，採石業，砂利，採取業"},
      {code: "04", name: "建設業"},
      {code: "05", name: "製造業"},
      {code: "06", name: "電気・ガス・熱供給・水道業"},
      {code: "07", name: "情報通信業"},
      {code: "08", name: "運輸業，郵便業"},
      {code: "09", name: "卸売業，小売業"},
      {code: "10", name: "金融業，保険業"},
      {code: "11", name: "不動産業，物品賃貸業"},
      {code: "12", name: "学術研究，専門・技術サービス業"},
      {code: "13", name: "宿泊業，飲食サービス業"},
      {code: "14", name: "生活関連サービス業，娯楽業"},
      {code: "15", name: "教育，学習支援業"},
      {code: "16", name: "医療，福祉"},
      {code: "17", name: "複合サービス事業"},
      {code: "18", name: "サービス業"},
      {code: "19", name: "公務"},
      {code: "20", name: "分類不能の産業"},
    ];
  }

  ngOnInit() {
    this.data.menuPageTitle = 'wf-contract-list';
    this.spinner.show();
    if(this.check == true){
      this.cancel_flg = '1';
    }else{
      this.cancel_flg = ''
    }
    this.rest.Get_WFAccount(this.data.uuid).subscribe(
      (res)=>{
        this.management_company_code = res.data.management_company_code;
        const body = {
          data:{
            user_uuid: this.data.uuid,
            company_name: this.CompanyName,
            tel: this.Telephone,
            cancel_flg: this.cancel_flg,
            management_company_code: this.management_company_code,
            business_type: this.business_type
          }
        };
        console_log(body);
        this.rest.Get_Contracts(this.data.uuid, this.CompanyName, this.Telephone, this.cancel_flg, this.management_company_code, this.business_type).subscribe(
          (res)=>{
              this.filteredItems = res.data.CorporationInfo;
              this.ContractCount = res.contract_record_count;
              // if (res.record_count >= 500) {
              //   document.getElementById('limit500').style.display = 'block';
              // } else {
              //   document.getElementById('limit500').style.display = 'none';
              // }
              this.currentIndex = 1;
              this.pageStart = 1;
              this.pages = 6;

              this.pageNumber = parseInt(
                '' + this.filteredItems.length / this.pageSize
              );
              if (this.filteredItems.length % this.pageSize != 0) {
                this.pageNumber++;
              }
              if (this.pageNumber < this.pages) {
                this.pages = this.pageNumber;
              }
              this.refreshItems();
              this.spinner.hide();
          },
          (err)=>{
            console_log(err);
            this.spinner.hide();
            this.router.navigate(['/wf-contract-err', {code: err.error.error.code}]);
          }
        );
      },
      (err)=>{
        console_log(err);
        this.spinner.hide();
        this.router.navigate(['/wf-contract-err', {code: err.error.error.code}]);
      }
    );
    this.rest.Get_Screenauth(this.data.uuid).subscribe(
      (res) => {
        this.pages1 = res.data;
        for (let i = 0; i < this.pages1.length; i++) {
          if (this.pages1[i].pagename == 'wf-contract-list-detail') {
            console_log('wf-contract-list-detail');
            if (this.pages1[i].auth == 'F' || this.pages1[i].auth == 'R') {
              this.wf_contract_list_detail = true;
            }
            if (this.pages1[i].auth == 'D') {
              this.wf_contract_list_detail = false;
            }
          }
        }
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }
  fillArray(): any {
    var obj = new Array();
    for (
      var index = this.pageStart;
      index < this.pageStart + this.pages;
      index++
    ) {
      obj.push(index);
    }
    return obj;
  }

  refreshItems() {
    this.items = this.filteredItems.slice(
      (this.currentIndex - 1) * this.pageSize,
      this.currentIndex * this.pageSize
    );
    this.pagesIndex = this.fillArray();
  }

  prevPage() {
    if (this.currentIndex > 1) {
      this.currentIndex--;
    }
    if (this.currentIndex < this.pageStart) {
      this.pageStart = this.currentIndex;
    }
    this.refreshItems();
  }

  nextPage() {
    if (this.currentIndex < this.pageNumber) {
      this.currentIndex++;
    }
    if (this.currentIndex >= this.pageStart + this.pages) {
      this.pageStart = this.currentIndex - this.pages + 1;
    }
    this.refreshItems();
  }

  setPage(index: number) {
    this.currentIndex = index;
    this.refreshItems();
  }

  selectedRadios(id) {
    this.pageSize = id;
    this.currentIndex = 1;
    this.pageStart = 1;
    this.pages = 6;

    this.pageNumber = parseInt('' + this.filteredItems.length / this.pageSize);
    if (this.filteredItems.length % this.pageSize != 0) {
      this.pageNumber++;
    }

    if (this.pageNumber < this.pages) {
      this.pages = this.pageNumber;
    }
    this.refreshItems();
  }
  details(list) {
    this.data.backButton = '/wf-contract-list';
    this.router.navigate(['/wf-contract-list-detail',{uuid: list.uuid}]);
  }

  csv(){
    const bodyHC01 = {
      corporation_no : "法人番号",
      company_name : "会社名",
      business_type: "業種・業態",
      tel : "電話番号",
      mail_address : "メールアドレス",
      judge_state: "契約状況",
      acquired_name: "獲得企業名",
      user_count: "社員数",
      app_date : "申請日",
      contract_start_date : "契約日",
      contract_end_date : "解約日"
    }
    const body = {
      corporation_no : "法人番号",
      company_name : "会社名",
      business_type: "業種・業態",
      tel : "電話番号",
      mail_address : "メールアドレス",
      judge_state: "契約状況",
      user_count: "社員数",
      app_date : "申請日",
      contract_start_date : "契約日",
      contract_end_date : "解約日"
    }
    var csvItems = [];
    csvItems = this.filteredItems.map((_arrayElement) => Object.assign({}, _arrayElement));
    for(let i = 0; i < csvItems.length; i++){
      if(csvItems[i].business_type == '01'){
        csvItems[i].business_type = '農業・林業'
      } else if (csvItems[i].business_type == '02'){
        csvItems[i].business_type = '漁業'

      }else if (csvItems[i].business_type == '03'){
        csvItems[i].business_type = '鉱業，採石業，砂利，採取業'

      }else if (csvItems[i].business_type == '04'){
        csvItems[i].business_type = '建設業'

      }else if (csvItems[i].business_type == '05'){
        csvItems[i].business_type = '製造業'

      }else if (csvItems[i].business_type == '06'){
        csvItems[i].business_type = '電気・ガス・熱供給・水道業'

      }else if (csvItems[i].business_type == '07'){
        csvItems[i].business_type = '情報通信業'

      }else if (csvItems[i].business_type == '08'){
        csvItems[i].business_type = '運輸業，郵便業'

      }else if (csvItems[i].business_type == '09'){
        csvItems[i].business_type = '卸売業，小売業'

      }else if (csvItems[i].business_type == '10'){
        csvItems[i].business_type = '金融業，保険業'

      }else if (csvItems[i].business_type == '11'){
        csvItems[i].business_type = '不動産業，物品賃貸業'

      }else if (csvItems[i].business_type == '12'){
        csvItems[i].business_type = '学術研究，専門・技術サービス業'

      }else if (csvItems[i].business_type == '13'){
        csvItems[i].business_type = '宿泊業，飲食サービス業'

      }else if (csvItems[i].business_type == '14'){
        csvItems[i].business_type = '生活関連サービス業，娯楽業'

      }else if (csvItems[i].business_type == '15'){
        csvItems[i].business_type = '教育，学習支援業'

      }else if (csvItems[i].business_type == '16'){
        csvItems[i].business_type = '医療，福祉'

      }else if (csvItems[i].business_type == '17'){
        csvItems[i].business_type = '複合サービス事業'

      }else if (csvItems[i].business_type == '18'){
        csvItems[i].business_type = 'サービス業'

      }else if (csvItems[i].business_type == '19'){
        csvItems[i].business_type = '公務'

      }else if (csvItems[i].business_type == '20'){
        csvItems[i].business_type = '分類不能の産業'
      }
    }
    for(let i = 0; i < csvItems.length; i++){
      if(csvItems[i].judge_state == '90' && csvItems[i].contract_end_date != ''){
        csvItems[i].judge_state = '解約済'
      }else if(csvItems[i].judge_state == '90' && csvItems[i].contract_end_date == ''){
        csvItems[i].judge_state = '契約中'
      }else if(csvItems[i].judge_state == '02'){
        csvItems[i].judge_state = '審査中'
      }else if(csvItems[i].judge_state == '03'){
        csvItems[i].judge_state = '再審査可能NG'
      }else if(csvItems[i].judge_state == '05'){
        csvItems[i].judge_state = '再審査中'
      }else if(csvItems[i].judge_state == '01' || csvItems[i].judge_state == '04' || csvItems[i].judge_state == '99'){
        csvItems[i].judge_state = ''
      }
    }
    const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
    if(this.management_company_code == 'HC01'){
      const header = Object.keys(bodyHC01);
      const headerValue = Object.values(bodyHC01);
      this.csv1= csvItems.map(row => header.map(fieldName =>
      JSON.stringify(row[fieldName], replacer)).join(','));
      this.csv1.unshift(headerValue.join(','));
    }else{
      const header = Object.keys(body);
      const headerValue = Object.values(body);
      this.csv1= csvItems.map(row => header.map(fieldName =>
      JSON.stringify(row[fieldName], replacer)).join(','));
      this.csv1.unshift(headerValue.join(','));
    }
    this.csv1 = this.csv1.join('\r\n');

    // Create link and download

    this.today = new Date();
    this.today_date = this.datepipe.transform(this.today, 'yyyyMMddHHmmss');
    var a = '契約済み法人一覧_';
    var download_name;
    download_name = a + this.today_date;
    var link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(this.csv1));
    link.setAttribute('download', download_name + '.csv');
    link.style.visibility = 'hidden';
    for(let i = 0; i < csvItems.length; i++){
      if(csvItems[i].judge_state == '解約済' && csvItems[i].contract_end_date != ''){
        csvItems[i].judge_state = '90'
      }else if(csvItems[i].judge_state == '契約中' && csvItems[i].contract_end_date == ''){
        csvItems[i].judge_state = '90'
      }else if(csvItems[i].judge_state == '審査中'){
        csvItems[i].judge_state = '02'
      }else if(csvItems[i].judge_state == '再審査可能NG'){
        csvItems[i].judge_state = '03'
      }else if(csvItems[i].judge_state == '再審査中'){
        csvItems[i].judge_state = '05'
      }else if(csvItems[i].judge_state == ''){
        csvItems[i].judge_state = ''
      }
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  Search(){
    this.business_code = this.business_type;
    this.spinner.show();
    if(this.check == true){
      this.cancel_flg = '1';
    }else{
      this.cancel_flg = ''
    }


    for(let i = 0; i < this.BusinessType.length; i++){
      if(this.BusinessType[i].name == this.business_type){
        this.business_code =  this.BusinessType[i].code;
      }
    }

    const body = {
      data:{
        user_uuid: this.data.uuid,
        company_name: this.CompanyName,
        tel: this.Telephone,
        cancel_flg: this.cancel_flg,
        management_company_code: this.management_company_code,
        business_type: this.business_code
      }
    };
    console_log(body);
    this.rest.Get_Contracts(this.data.uuid, this.CompanyName, this.Telephone, this.cancel_flg,  this.management_company_code, this.business_code).subscribe(
      (res)=>{
        console_log(res);
        this.filteredItems = res.data.CorporationInfo;
        this.ContractCount = res.contract_record_count;
        // if (this.filteredItems.length >= 500) {
        //   document.getElementById('limit500').style.display = 'block';
        // } else {
        //   document.getElementById('limit500').style.display = 'none';
        // }
        this.currentIndex = 1;
        this.pageStart = 1;
        this.pages = 6;

        this.pageNumber = parseInt(
          '' + this.filteredItems.length / this.pageSize
        );
        if (this.filteredItems.length % this.pageSize != 0) {
          this.pageNumber++;
        }

        if (this.pageNumber < this.pages) {
          this.pages = this.pageNumber;
        }
        this.refreshItems();
        this.spinner.hide();
    },(err)=>{
      console_log(err);
      this.spinner.hide();
      this.router.navigate(['/wf-contract-err', {code: err.error.error.code}]);
      }
    );
  }
  pdf_download(uuid) {
    this.rest
      .Download_Regcertificates(this.data.uuid, uuid)
      .subscribe((res) => {
        if (res.code == 'S000001') {
          this.documentpdf = res.data.s3url;
          window.open(this.documentpdf, '_blank', '');
        }
      });
  }
  pdf_download_s3(uuid) {
    this.spinner.show();
    this.rest.Download_Contracts(this.data.uuid, uuid).subscribe(
        (res) => {
          if (res.code == 'S000001') {
            this.spinner.hide();
            window.open(res.data.s3url, '_blank', '');
          }
        },
        (err) => {
          console_log(err);
          this.spinner.hide();
          this.router.navigate(['/wf-contract-err', {code: err.error.error.code}]);
        }
      );
  }
  order(id){
    var apply_list:Array<Apply> = this.filteredItems;
    if(id == 1){
      apply_list.sort((a,b) =>  a.app_date < b.app_date ? 1 : a.app_date > b.app_date ? -1 : 0)	// descending
      this.items = apply_list.slice(
        (this.currentIndex - 1) * this.pageSize,
        this.currentIndex * this.pageSize
      );
      this.pagesIndex = this.fillArray();
    }else if(id == 2){
      apply_list.sort((a,b) => a.app_date < b.app_date ? -1 : a.app_date > b.app_date ? 1 : 0)	// Ascending
      this.items = apply_list.slice(
        (this.currentIndex - 1) * this.pageSize,
        this.currentIndex * this.pageSize
      );
      this.pagesIndex = this.fillArray();
    }else if(id == 3){
      apply_list.sort((a,b) => a.contract_start_date < b.contract_start_date ? 1 : a.contract_start_date > b.contract_start_date ? -1 : 0)	// descending
      this.items = apply_list.slice(
        (this.currentIndex - 1) * this.pageSize,
        this.currentIndex * this.pageSize
      );
      this.pagesIndex = this.fillArray();
    }else if(id == 4){
      apply_list.sort((a,b) => a.contract_start_date < b.contract_start_date ? -1 : a.contract_start_date > b.contract_start_date ? 1 : 0)	// Ascending
      this.items = apply_list.slice(
        (this.currentIndex - 1) * this.pageSize,
        this.currentIndex * this.pageSize
      );
      this.pagesIndex = this.fillArray();
    }else if(id == 5){
      apply_list.sort((a,b) => a.contract_end_date < b.contract_end_date ? 1 : a.contract_end_date > b.contract_end_date ? -1 : 0)	// descending
      this.items = apply_list.slice(
        (this.currentIndex - 1) * this.pageSize,
        this.currentIndex * this.pageSize
      );
      this.pagesIndex = this.fillArray();
    }else{
      apply_list.sort((a,b) => a.contract_end_date < b.contract_end_date ? -1 : a.contract_end_date > b.contract_end_date ? 1 : 0)	// Ascending
      this.items = apply_list.slice(
        (this.currentIndex - 1) * this.pageSize,
        this.currentIndex * this.pageSize
      );
      this.pagesIndex = this.fillArray();
    }
  }
}
class Apply{
  app_date: String
  company_name: String
  contract_end_date: String
  contract_start_date: String
  corporation_no: String
  mail_address: String
  tel: String
  uuid: String
}
